module.exports = __webpack_public_path__ + "static/media/file-ppt.370380d5.svg";